import { render, staticRenderFns } from "./BalanceList.vue?vue&type=template&id=4c772be9&scoped=true&"
import script from "./BalanceList.vue?vue&type=script&lang=js&"
export * from "./BalanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c772be9",
  null
  
)

export default component.exports